import type { PlatformHealth } from "@aco/core";

/** Anything the reader should be warned about before trusting the numbers. */
export function isUnhealthy(item: PlatformHealth): boolean {
  return item.stale || item.missingInRange || (item.missingDays ?? 0) > 0;
}

/** "3 days still importing" or "3 days missing" for a gap inside the range. */
export function describeMissingDays(item: PlatformHealth): string {
  const missing = item.missingDays ?? 0;
  const importing = item.importingDays ?? 0;
  const unit = missing === 1 ? "day" : "days";
  return importing > 0 ? `${missing} ${unit} still importing` : `${missing} ${unit} missing`;
}
